import React, { useEffect } from 'react';
import { Typography, Grid } from '@material-ui/core';
import { ResponsiveContainer, PieChart, Pie, Cell, Sector, Customized } from 'recharts';
import ChartLegend from './ChartLegend';

const COLORS = ['#1976d2', '#00796b', '#689f38', '#fbc02d', '#ff6d00', '#d32f2f', '#7b1fa2'];
const activeIndex = 0;
let fcx = 0;
let fcy = 0;

const renderActiveShape = (props) => {
    const {
        cx, cy, innerRadius, outerRadius, startAngle, endAngle,
        fill, payload, percent,
    } = props;
    fcx = cx;
    fcy = cy + 15;
    return (
        <g>
            <text x={cx} y={cy - 25} textAnchor="middle" className="pielabel-name" style={{ display: activeIndex >= 0 ? '' : 'none' }}>
            {payload.name}
            </text>
            <text x={cx} y={cy + 15} textAnchor="middle" className="pielabel-value" style={{ display: activeIndex >= 0 ? '' : 'none' }}>
            {`${payload.value.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}件`}
            </text>
            <text x={cx} y={cy + 45} textAnchor="middle" className="pielabel-percent" style={{ display: activeIndex >= 0 ? '' : 'none' }}>
            {`${(percent * 100).toFixed(2)}%`}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius - 7}
                outerRadius={outerRadius + 7}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
                className="cell-active"
            />
        </g>
    );
}

function Chart(props) {
    
    const { values, setActiveIndex, handleChange, setShishoKozoKubun, setChartVisibleStyle } = props;
    const { activeIndex, chartVisibleStyle, chartParam, chartData, firstVisibleFlg, setFirstVisibleFlg } = values;
    const { shishoKozoKubun } = chartParam;
    const { data, total } = chartData;

    const pieMouseEnter = (data, index) => {
        console.log('pieMouseEnter() - index:' + index);
        setActiveIndex(index);
    };
    const pieMouseLeave = (data, index) => {
        console.log('pieMouseLeave() - mouse out');
        setActiveIndex(-1);
    };

    const Total = () => { 
        return (
            <g style={{ display: activeIndex === -1 ? '' : 'none', position: 'relative', }}>
                <text x={fcx} y={fcy} textAnchor="middle" className="pielabel-value" style={{ position: 'absolute'}}>
                    {`${total.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}件`}
                </text>
            </g>
        );
    };
    
    useEffect(() => {
        if (firstVisibleFlg.current) {
            setTimeout(() => {
                setActiveIndex(-1);
            }, 200);
            setFirstVisibleFlg(false);
        }
    }, [firstVisibleFlg, setFirstVisibleFlg, setActiveIndex]);

    return (
        <div className="chart-wrap">
            <Typography variant="h5" component="h6" align="center" className="chart-title" style={shishoKozoKubun === '' ? {backgroundColor: '#3657A1'} : {backgroundColor: '#E28C0A'}}>
                {shishoKozoKubun === '' ? '支承構造ごとの採用実績' : '製品構造ごとの採用実績'}
            </Typography>
            <div className="chart-description" align="center">
                支承設計のご相談は、ページ下部の「技術相談・問い合わせ」よりご用命ください
            </div>
            <div style={chartVisibleStyle}>
                <Grid container alignItems="center" spacing={0} className="chart-container">
                    <Grid item xs={12} md={6}>
                        <div className="chart">
                            <ResponsiveContainer>
                                <PieChart>
                                    <Pie 
                                        data={data} 
                                        dataKey="value"
                                        labelLine={false}
                                        startAngle={90}
                                        endAngle={-270}
                                        innerRadius="70%"
                                        outerRadius="95%"
                                        activeIndex={activeIndex}
                                        activeShape={renderActiveShape}
                                        onClick={pieMouseEnter}
                                        onMouseEnter={pieMouseEnter}
                                        onMouseLeave={pieMouseLeave}
                                        paddingAngle={1}
                                    >
                                        {data.map((entry, index) => (
                                            <Cell className={'cell-bgcolor'} name={`${data[index].name}`} key={`cell-${index}`} fill={COLORS[index % COLORS.length]} index={index}/>
                                        ))}
                                    </Pie>
                                    <Customized key="total-number" component={Total} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ChartLegend values={values} handleChange={handleChange} setActiveIndex={setActiveIndex} setShishoKozoKubun={setShishoKozoKubun} setChartVisibleStyle={setChartVisibleStyle} COLORS={COLORS}/>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default Chart;
